var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaire_classify"},[_c('crumbs',{staticClass:"breadcrumb-container"}),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }